import { PersonneModel } from './personne.model';


export class CompoFoyerModel {
    public role: string;
    public personne: PersonneModel;
}
